/**
 * A Designer Workflow is a high-level state the user can be in when working in the Designer.
 * The workflow the user is in typically dictates the set of available functionality available to
 * the user, and the UI they can see and interact with.

 * The workflow value is stored in the `DesignerStore`.
 */
export const DESIGNER_WORKFLOWS = Object.freeze({
  /**
   * Workflow for previewing the site in the Designer
   */
  PREVIEW: 'preview',
  /**
   * Workflow for commenting (annotations) in the Designer
   */
  COMMENT: 'comment',
  /**
   * Workflow for building and editing pages. This is the default mode.
   */
  CANVAS: 'canvas',
  /**
   * Workflow for Logic Flows
   */
  LOGIC_FLOWS: 'logicFlows',
  /**
   * Workflow for editing dynamic data in a dedicated view including CMS, Ecomm and Users.
   */
  DYNAMIC_DATA: 'dynamicData',
  /**
   * Workflow for analytics and optimization.
   */
  OPTIMIZATION: 'optimization',
  /**
   * Workflow for editing optimization click goals.
   */
  OPTIMIZATION_CLICK_GOAL: 'optimizationClickGoal',
  /**
   * Workflow for editing optimization redirect test.
   */
  OPTIMIZATION_REDIRECT_TEST: 'optimizationRedirectTest',
  /**
   * Workflow for analyze visual view
   */
  ANALYZE_VISUAL_VIEW: 'analyzeVisualView',
  /**
   * Workflow for app gen in Designer
   */
  CODE_MODE: 'webApps',
  /**
   * Workflow for AI Agents
   */
  AGENTS: 'agents',
  /**
   * Workflow for the Campaigns Home — a dedicated home for campaign-kind sites.
   */
  CAMPAIGNS_HOME: 'campaignsHome',
});
